/**
 * Copyright (c) 2019 Burst Apps Team
 * Modified (c) 2022 Signum Network
 */
import {calculateMinimumCreationFee} from '@turajs/contracts';
import {ChainService} from '../../../service';
import {PublishContractArgs} from '../../../typings/args';
import {UnsignedTransaction} from '../../../typings/unsignedTransaction';
import {DefaultDeadline} from '../../../constants';
import {signIfPrivateKey} from '../../../internal/signIfPrivateKey';
import {generateDataStack} from '@turajs/contracts/out/generateDataStack';


/**
 * Use with [[ApiComposer]] and belongs to [[ContractApi]].
 *
 * See details at [[ContractApi.publishContract]]
 * @module core.api.factories
 */
export const publishContract = (service: ChainService) =>
    (args: PublishContractArgs) => signIfPrivateKey(service, args, async (a: PublishContractArgs) => {

        const {dataHex, dataPageCount} = generateDataStack(a.data || []);
        const feeNQT = a.feePlanck || calculateMinimumCreationFee({
            dataHex,
            codeHex: a.codeHex
        }).getPlanck();

        const parameters = {
            code: a.codeHex,
            deadline: a.deadline || DefaultDeadline,
            description: a.description,
            feeNQT,
            minActivationAmountNQT: a.activationAmountPlanck,
            name: a.name,
            publicKey: a.senderPublicKey,
            data: dataHex || undefined,
            dpages: dataPageCount || 1,
            cspages: 1,
            uspages: 1,
            broadcast: true,
        };

        return service.send<UnsignedTransaction>('createATProgram', parameters);
    });
